import { render, staticRenderFns } from "./DialogVX.vue?vue&type=template&id=5b06c428&"
import script from "./DialogVX.vue?vue&type=script&lang=js&"
export * from "./DialogVX.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports